export default __webpack_public_path__ + "static/media/paddelPlayer3wb.df450f2e.png";